module.exports = __webpack_public_path__ + "static/main-event-a3ae556d7f74b61505a594c266645eb5.png";